export default __webpack_public_path__ + "static/media/NEO NX 110_4.8bbdc880.webp";